<template>
  <div id="sysHistory">
    <BaseDialog
      title="历史系统更新公告"
      :showVisible ="dialogVisible"
      @close="cancel"
      :isCancel = "false"
      :isConfirm = "false"
      size="LARGE"
    >
      <template v-slot:content>
      <div class="elDialog" v-loading="loadings" :element-loading-text="loadingText">
        <div class="item" v-for="(item,index) in listdata" :key="index">
          <div class="left">
            <div class="mb10">{{item.title}}</div>
            <div class="list">{{item.summary}}</div>
            <div class="list">时间段：{{getLocalTime(item.startNotice,'haveSeconds')}} - {{getLocalTime(item.endNotice,'haveSeconds')}}</div>
          </div>
          <div class="right" @click="checkDetail(item)">
            查看详情
          </div>
        </div>
      </div>
      <div  class="dialog-footer" align="right">
        <el-pagination
        	:current-page="filterData.currentPage"
        	:page-size="filterData.maxResult"
        	background
        	:total="totalNum"
        	@current-change="currentChange"
        	@size-change="sizeChange"
        	layout="total, prev, pager, next, sizes, jumper">
        </el-pagination>
      </div>
      </template>
    </BaseDialog>
  </div>
</template>

<script>
  import bus from '@/assets/utils/bus'
  import {getLocalTime} from '@/assets/utils/index'
  import BaseDialog from '@/components/dialog/BaseDialog.vue';
  export default {
    props:['defaultData'],
    data(){
      return {
        getLocalTime:getLocalTime,
        dialogVisible:false,
        loadings:false,
        loadingText:'查询中',
        totalNum:10,
        filterData:{
          currentPage:1,
          maxResult:10,
          state:'',
          systemType:'1'
        },
        listdata:[]
      }
    },
    components: {
      BaseDialog
    },
    computed: {

    },
    created(){
      bus.$on('showdilog',val=>{
        this.dialogVisible=true
      })
      bus.$on('showhistory',val=>{
        this.dialogVisible=val
        this.historyList();
      })
    },
    methods:{
      historyList(pages,size){//查看详情
      this.$set(this.filterData,'currentPage',pages?pages:this.filterData.currentPage)
      this.$set(this.filterData,'maxResult',size?size:this.filterData.maxResult)
        this.$http.post('msg/notify/findHistory', this.filterData,{form:'houtai'}).then(res=>{
        	if(res && res.data.code == 200) {
            this.listdata=res.data.data.list
            this.totalNum=res.data.data.totalCount
        	}
        })
      },
      checkDetail(item){
        this.dialogVisible=false
        bus.$emit('returndetail',item)
      },
      cancel(){
        this.dialogVisible=false
        // bus.$emit('showgongao','')
      },
      //页数
      currentChange (val) {
      	this.filterData.currentPage = val;
      	let size=this.filterData.maxResult
      	this.historyList(val,size);
      },
      //条数
      sizeChange (val) {
      	this.filterData.maxResult = val;
      	let pages=this.filterData.currentPage
      	this.historyList(pages,val);
      },
    },
    mounted() {

    },
    watch:{
      defaultData: {
        handler(newName, oldName) {
          this.dialogVisible = newName.show;

        },
        deep:true,
      }
    }
  }
</script>
<style lang="less">
  #sysHistory{
    .el-dialog__header{
      border-bottom: none !important;
    }
    .el-dialog__footer{
      border-top: none !important;
    }
  }
</style>
<style lang="less" scoped>
  .dialog_title{
    width: 53%;
    display: flex;
    justify-content: space-between;
    .el-icon-arrow-left{
      font-size: 18px;
      cursor: pointer;
    }
  }
  .el-button.active{
    background-color: #268AFF;
    color: #fff;
  }
  .elDialog{
    height: 500px;
    overflow-y:auto;
    margin: 0 -24px 48px;
    .item{
      display: flex;
      border-bottom: 1px solid #E0E0E0;
      margin: 0 24px 20px;
      .left{
        flex: 1;
        .list{
          margin-bottom: 20px;
        }
      }
      .right{
        width: 100px;
        color: #269D7B;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/SystemBulletin.vue